module.exports = __webpack_public_path__ + "static/media/PB_amplify.553472e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PB_amplify.png
// module id = 1274
// module chunks = 0